'use client';

import type { ReactNode } from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

/** Aligns with `data-theme` used across SCSS and `Header` / layout scripts. */
export default function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute='data-theme'
      defaultTheme='light'
      enableSystem={false}
      themes={['light', 'dark']}
      disableTransitionOnChange
      storageKey='theme'
    >
      {children}
    </NextThemesProvider>
  );
}
